import styled from '@emotion/styled'

export const AdminContainer = styled.div({
  display: 'flex',
  marginTop:'2rem',
  flex: 1,
  flexDirection: 'row',
  justifyContent:'center',
  width: '100%',
  height: '100vh',
})


